import LinkText from "lang/LinkText";
import Translate from "lang/Translate";
import TranslateParse from "lang/TranslateParse";
import { Fragment } from "react";

const UnauthorisedError = () => {
  return (
    <Fragment>
      <div className="tile">
        <div className="error-content">
          <div>
            <b><Translate text="Content.noAccess_SorryNoAccess" /></b>
          </div>
          <div>
            <TranslateParse 
              text="Content.noAccess_SorryNoAccessDescription"
              inject={[
                { 
                  linkText: "Content.createABlockSignalLinkforNoAccess", 
                  renderItem: <LinkText to="https://hrbcaprod.service-now.com/hrb/"/> 
                }
              ]}
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default UnauthorisedError